// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

import mapboxgl from 'mapbox-gl';
import { Popup } from 'mapbox-gl';
import { intcomma } from 'journalize';

import syncMaps from '@mapbox/mapbox-gl-sync-move';

mapboxgl.accessToken =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

//////////////////////////////
//////// CURRENT MAP /////////
//////////////////////////////

// CURRENT BOUNDARIES
const CURR_TILESET_ID = 'latimes.02wo56c1';
const CURR_SOURCE = 'currentAreas_2-2uwvoe';
const CURR_SOURCE_LAYER = 'currentAreas_2-2uwvoe';

// map
var currentMap = new mapboxgl.Map({
  container: 'current-map',
  style: 'mapbox://styles/latimes/ckx865w6y9pik14lgjj7iwmo8', // From style page
  pitchWithRotate: false, // this prevents accidentially changing the pitch
  center: [-119.861, 37.526], // starting position [lng, lat]
  maxZoom: 9,
  minZoom: 5,
  zoom: 5,
  fitBoundsOptions: {
    padding: { top: 80, right: 80, bottom: 80, left: 80 },
  },
});

// let hoveredStateId = null;

currentMap.on('load', () => {
  currentMap.addSource(CURR_SOURCE, {
    type: 'vector',
    url: `mapbox://${CURR_TILESET_ID}`,
    generateId: true,
  });

  currentMap.addLayer(
    {
      'id': 'cb-hover-stroke',
      'type': 'line',
      'source': CURR_SOURCE,
      'source-layer': CURR_SOURCE_LAYER,
      'paint': {
        'line-color': '#666666',
        'line-width': 1,
        'line-opacity': 0.6,
        // 'line-opacity': [
        //   'case',
        //   ['boolean', ['feature-state', 'hover'], false],
        //   1,
        //   0,
        // ],
      },
    },
    'airport-label'
  );

  currentMap.addLayer(
    {
      'id': 'current-hover-opacity',
      'type': 'fill',
      'source': CURR_SOURCE,
      'source-layer': CURR_SOURCE_LAYER,
      'paint': {
        'fill-color': '#eedd81',
        'fill-opacity': 0,
      },
    },
    'airport-label'
  );

  currentMap.addLayer({
    'id': 'current-data-layer',
    'type': 'fill',
    'source': CURR_SOURCE,
    'source-layer': CURR_SOURCE_LAYER,
    'paint': {
      'fill-color': '#FDFF8F',
      'fill-opacity': 0,
    },
  });

  currentMap.addControl(
    new mapboxgl.NavigationControl({ showCompass: false }),
    'top-left'
  );
  // FORCE CENTER ON LA TO START
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  if (viewportWidth > 767) {
  } else {
    currentMap.setCenter([-118.2439, 34.0544]);
    currentMap.setZoom(8);
  }

  highlightShape('currentMap', 34, -118.2439, 34.0544);
});

//////////////////////////////
////// PROPOSED MAP //////////
//////////////////////////////

// FUTURE BOUNDARIES
const TILESET_ID = 'latimes.2nec2s3e'; // From Tileset
const SOURCE = 'futureAreas_v6-babvsp';
const SOURCE_LAYER = 'futureAreas_v6-babvsp'; // layer name

// map
var proposedMap = new mapboxgl.Map({
  container: 'proposed-map',
  style: 'mapbox://styles/latimes/ckx865w6y9pik14lgjj7iwmo8', // From style page
  pitchWithRotate: false, // this prevents accidentially changing the pitch
  center: [-119.861, 37.526], // starting position [lng, lat]
  maxZoom: 9,
  minZoom: 5,
  zoom: 5,
  fitBoundsOptions: {
    padding: { top: 80, right: 80, bottom: 80, left: 80 },
  },
});

proposedMap.on('load', () => {
  proposedMap.addSource(SOURCE, {
    type: 'vector',
    url: `mapbox://${TILESET_ID}`,
    generateId: true,
  });

  proposedMap.addLayer(
    {
      'id': 'fb-hover-stroke',
      'type': 'line',
      'source': SOURCE,
      'source-layer': SOURCE_LAYER,
      'paint': {
        'line-color': '#666666',
        'line-width': 1,
        'line-opacity': 0.6,
      },
    },
    'water-point-label'
  );

  proposedMap.addLayer(
    {
      'id': 'proposed-hover-opacity',
      'type': 'fill',
      'source': SOURCE,
      'source-layer': SOURCE_LAYER,
      'paint': {
        'fill-color': '#eedd81',
        'fill-opacity': 0,
      },
    },
    'airport-label'
  );

  proposedMap.addLayer({
    'id': 'proposed-data-layer',
    'type': 'fill',
    'source': SOURCE,
    'source-layer': SOURCE_LAYER,
    'paint': {
      'fill-color': '#FDFF8F',
      'fill-opacity': 0,
    },
  });

  proposedMap.addControl(
    new mapboxgl.NavigationControl({ showCompass: false }),
    'top-left'
  );

  //FORCE LA HIGHLIHGHT
  highlightShape('proposedMap', '34', -118.2439, 34.0544);
});

const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  countries: 'us',
  region: 'ca',
  placeholder: 'Enter an address to find its district',
  bbox: [-124.410607, 32.534231, -114.134458, 42.009659],
  mapboxgl: mapboxgl,
});

//document.getElementById('geocoder').appendChild(geocoder.onAdd(currentMap));
geocoder.addTo('#geocoder');

let hoveredStateId = null;

function getData(party) {
  let array = {};
  if (party.winner == 'REP') {
    array.winnerParty = 'Republican';
    array.winnerPer = party.repPercent;
    array.loserParty = 'Democrat';
    array.loserPer = party.demPercent;
  } else {
    array.winnerParty = 'Democrat';
    array.winnerPer = party.demPercent;
    array.loserParty = 'Republican';
    array.loserPer = party.repPercent;
  }
  return array;
}

var el_current = document.createElement('div');
el_current.className = 'map-point';

var el_proposed = document.createElement('div');
el_proposed.className = 'map-point';

var mapMarker_current = new mapboxgl.Marker(el_current);
var mapMarker_proposed = new mapboxgl.Marker(el_proposed);

geocoder.on('result', function (e) {
  // console.log(e.result.center);
  // console.log(e.result.context[1]['text']);
  var test = e.result.context[e.result.context.length - 2]['text'];
  // console.log(test);

  if (
    test !== 'California'
    // typeof test_features == 'undefined' ||
    // test_features.layer.id != 'current-data-layer'
  ) {
    // NOT IN CA
    // console.log('notCA');
    errorText();
  } else {
    document.querySelector('.error').innerHTML = '';

    currentMap.flyTo({
      center: e.result.center,
      essential: true,
      zoom: 9,
    });

    // USE THE DATA
    currentMap.once('moveend', function () {
      var current_geocoder_point = currentMap.project(e.result.center);
      var current_features = currentMap.queryRenderedFeatures(
        current_geocoder_point
      )[0];

      var geocoder_point = proposedMap.project(e.result.center);
      var features = proposedMap.queryRenderedFeatures(geocoder_point)[0];

      mapMarker_current.remove();
      mapMarker_current.setLngLat(e.result.center).addTo(currentMap);

      mapMarker_proposed.remove();
      mapMarker_proposed.setLngLat(e.result.center).addTo(proposedMap);
      // console.log(typeof current_features == 'undefined');

      roboText('currentMap', current_features.properties);
      roboText('proposedMap', features.properties);

      highlightShape(
        'currentMap',
        current_features.properties.district,
        current_geocoder_point.x,
        current_geocoder_point.y
      );

      highlightShape(
        'proposedMap',
        features.properties.DISTRICT,
        geocoder_point.x,
        geocoder_point.y
      );
    });
  }
});

function errorText() {
  document.querySelector('.error').innerHTML =
    '<span>Please search an address within California.</span>';
}

function roboText(map, prop) {
  let sentenceData = getData(prop);

  if (map == 'currentMap') {
    document.querySelector(
      '.map-label.current'
    ).innerHTML = `<span>Current: <span class="highlight">CA-${prop.district}</span></span>`;
    document.querySelector(
      '.map-text#current'
    ).innerHTML = `This district is represented by <span class="highlight">${prop.full_name} (${prop.party})</span>. Registered voters here are <span class="highlight">${sentenceData.winnerPer}% ${sentenceData.winnerParty}</span> and <span style="white-space: nowrap;"><span class="highlight">${sentenceData.loserPer}% ${sentenceData.loserParty}</span>.</span>`;
  } else if (map == 'proposedMap') {
    document.querySelector(
      '.map-label.new'
    ).innerHTML = `<span>New: <span class="highlight">CA-${prop.DISTRICT}</span></span>`;
    document.querySelector(
      '.map-text#proposed'
    ).innerHTML = `Under the new lines, registered voters in this district would be <span class="highlight">${sentenceData.winnerPer}% ${sentenceData.winnerParty}</span>  and <span style="white-space: nowrap;"><span class="highlight">${sentenceData.loserPer}% ${sentenceData.loserParty}</span>.</span>`;
  }
}

function highlightShape(map, id, x, y) {
  if (map == 'currentMap') {
    currentMap.setFilter('current-hover-opacity', ['in', 'district', id]);
    currentMap.setPaintProperty('current-hover-opacity', 'fill-opacity', 0.6);
  } else {
    proposedMap.setFilter('proposed-hover-opacity', ['in', 'DISTRICT', id]);
    proposedMap.setPaintProperty('proposed-hover-opacity', 'fill-opacity', 0.6);
  }
}

syncMaps(currentMap, proposedMap);

currentMap.on('click', 'current-data-layer', (e) => {
  document.querySelector('.error').innerHTML = '';
  const points = [e.point.x, e.point.y];

  // Find features intersecting point
  const selectedFeatures = currentMap.queryRenderedFeatures(points, {
    layers: ['current-data-layer'],
  });

  const district = selectedFeatures.map(
    (feature) => feature.properties.District2010
  );

  mapMarker_current.remove();
  mapMarker_current.setLngLat(e.lngLat).addTo(currentMap);

  mapMarker_proposed.remove();
  mapMarker_proposed.setLngLat(e.lngLat).addTo(proposedMap);

  currentMap.setFilter('current-hover-opacity', [
    'in',
    'District2010',
    ...district,
  ]);
  currentMap.setPaintProperty('current-hover-opacity', 'fill-opacity', 0.6);

  roboText('currentMap', selectedFeatures[0].properties);

  // same for proposed
  let proposedProp = proposedMap.queryRenderedFeatures([
    e.point.x,
    e.point.y,
  ])[0].properties;

  highlightShape('proposedMap', proposedProp.DISTRICT, e.point.x, e.point.y);

  roboText('proposedMap', proposedProp);
});
